module.exports = __webpack_public_path__ + "static/media/_MIC2632.thumbnail.3ccf5541.png";